var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"padding":"50px","margin":"0 auto","text-align":"center"}},[_c('h1',[_vm._v(" Loading ")])])}]

export { render, staticRenderFns }